import React, { useEffect, createElement } from 'react';
import { AlertCircleIcon } from 'lucide-react';
export function YtJuevesResults() {
  const videoTestimonials = [{
    id: '3cr3t5esqv',
    name: 'Testimonio 1'
  }, {
    id: 'ui7vp4u54s',
    name: 'Testimonio 2'
  }, {
    id: '1h6xcfjlz3',
    name: 'Testimonio 3'
  }, {
    id: 'y5kyufgdri',
    name: 'Testimonio 4'
  }];
  useEffect(() => {
    // Load Wistia player script
    const script1 = document.createElement('script');
    script1.src = 'https://fast.wistia.com/player.js';
    script1.async = true;
    document.head.appendChild(script1);
    // Load individual video scripts
    videoTestimonials.forEach(video => {
      const script = document.createElement('script');
      script.src = `https://fast.wistia.com/embed/${video.id}.js`;
      script.async = true;
      script.type = 'module';
      document.head.appendChild(script);
    });
    return () => {
      // Cleanup scripts on unmount
      const scripts = document.head.querySelectorAll('script[src*="wistia"]');
      scripts.forEach(script => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
    };
  }, []);
  return <section data-id="element-885">
      <style dangerouslySetInnerHTML={{
      __html: `
          wistia-player[media-id='3cr3t5esqv']:not(:defined) { 
            background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/3cr3t5esqv/swatch'); 
            display: block; 
            filter: blur(5px); 
            padding-top:177.78%; 
          }
          wistia-player[media-id='ui7vp4u54s']:not(:defined) { 
            background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/ui7vp4u54s/swatch'); 
            display: block; 
            filter: blur(5px); 
            padding-top:177.78%; 
          }
          wistia-player[media-id='1h6xcfjlz3']:not(:defined) { 
            background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/1h6xcfjlz3/swatch'); 
            display: block; 
            filter: blur(5px); 
            padding-top:177.78%; 
          }
          wistia-player[media-id='y5kyufgdri']:not(:defined) { 
            background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/y5kyufgdri/swatch'); 
            display: block; 
            filter: blur(5px); 
            padding-top:177.78%; 
          }
        `
    }} data-id="element-886" />
      <div className="bg-gray-800 bg-opacity-50 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-887">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-6 md:mb-8 text-center leading-tight" data-id="element-888">
          Experiencias compartidas por algunos estudiantes
        </h2>
        <p className="text-lg md:text-xl text-center text-gray-300 mb-8 md:mb-10 leading-relaxed max-w-3xl mx-auto" data-id="element-889">
          Algunos estudiantes han compartido que, tras aplicar de forma
          consistente los conceptos educativos abordados en la formación,
          lograron:
        </p>

        {/* Results List */}
        <div className="max-w-3xl mx-auto mb-8" data-id="element-890">
          <ul className="space-y-4 text-left" data-id="element-891">
            <li className="flex items-start" data-id="element-892">
              <span className="text-green-500 mr-3 flex-shrink-0 mt-1" data-id="element-893">✓</span>
              <span className="text-base md:text-lg text-gray-300 leading-relaxed" data-id="element-894">
                Publicar y lanzar sus primeros productos digitales
              </span>
            </li>
            <li className="flex items-start" data-id="element-895">
              <span className="text-green-500 mr-3 flex-shrink-0 mt-1" data-id="element-896">✓</span>
              <span className="text-base md:text-lg text-gray-300 leading-relaxed" data-id="element-897">
                Comprender mejor cómo estructurar un proyecto online
              </span>
            </li>
            <li className="flex items-start" data-id="element-898">
              <span className="text-green-500 mr-3 flex-shrink-0 mt-1" data-id="element-899">✓</span>
              <span className="text-base md:text-lg text-gray-300 leading-relaxed" data-id="element-900">
                Desarrollar procesos más organizados para su negocio
              </span>
            </li>
          </ul>
        </div>

        {/* Main Result Image */}
        <div className="max-w-2xl mx-auto mb-8" data-id="element-901">
          <div className="relative rounded-xl md:rounded-2xl overflow-hidden shadow-2xl" data-id="element-902">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iDfM4d2o3TiJ8yUUGm66kX/IMG_1139.jpg" alt="Ejemplos ilustrativos" className="w-full h-auto" data-id="element-903" />
          </div>
        </div>

        {/* Important Disclaimer - UPGRADED */}
        <div className="bg-yellow-900 bg-opacity-30 border-2 border-yellow-600 rounded-lg md:rounded-xl p-6 md:p-8 mb-8 max-w-3xl mx-auto" data-id="element-904">
          <div className="flex items-start" data-id="element-905">
            <AlertCircleIcon className="h-6 w-6 md:h-7 md:w-7 text-yellow-500 mr-3 md:mr-4 flex-shrink-0 mt-1" data-id="element-906" />
            <div data-id="element-907">
              <p className="font-semibold text-yellow-300 mb-3 text-base md:text-lg" data-id="element-908">
                Ejemplos Ilustrativos
              </p>
              <p className="text-gray-300 text-sm md:text-base leading-relaxed" data-id="element-909">
                Las imágenes y ejemplos mostrados durante la masterclass tienen
                fines educativos e ilustrativos. No representan resultados
                típicos ni garantizados.
              </p>
            </div>
          </div>
        </div>

        {/* Video Testimonials */}
        <div className="mb-8" data-id="element-910">
          <h3 className="text-xl md:text-2xl font-bold text-center text-white mb-8" data-id="element-911">
            Escucha lo que dicen algunos estudiantes
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-6xl mx-auto" data-id="element-912">
            {videoTestimonials.map(video => <div key={video.id} className="bg-gray-900 bg-opacity-50 rounded-xl overflow-hidden border border-gray-700" data-id="element-913">
                <div className="aspect-[9/16]" data-id="element-914">
                  <wistia-player media-id={video.id} aspect="0.5625" data-id="element-915"></wistia-player>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}